<ul class="nav nav-tabs justify-content-start">
    <li class="nav-item">
      <a class="nav-link" routerLink="reporteClientes" routerLinkActive="active"><b>Reporte Clientes</b></a>
    </li>
    <li  class="nav-item" >
      <a class="nav-link" routerLink="descargarDatos" routerLinkActive="active"><b>Descargar Datos</b></a>
    </li>
</ul>
<router-outlet></router-outlet>
